import { useState } from 'react';
import './index.css';
import _ from '../../../_';
import { useGlobal } from '../../../context/global';

const Tab = ({ tabs, def, render, syncRef }) => {

  var [active, setActive] = useState(def || 0)

  return (
    <div className='tab-main'>

      <div className='tab-tabs'>
        {
          tabs.map((tab, i) =>
            <div className={`tab-tab ${active == i ? 'active' : ''}`} style={{ width: `${100 / (tabs.length) || 1}%` }} key={tab.header} onClick={() => { setActive(i) }}>
              <div className={`tab-head`}>{tab.header}</div>
            </div>
          )
        }
      </div>

      <div>
        {
          render ?
            tabs[active].comp
            :
            <div className='tab-ch'>
              {
                tabs.map((tab, i) => <div style={{ display: active != i ? 'none' : '' }}>{tab.comp}</div>)
              }
            </div>
        }
      </div>

    </div>
  )
}

export default Tab;
